import React from "react";
import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import TodoItem from "./TodoItem";
import Error from "./ui/Error";
import TodoLoader from "./ui/TodoLoader";

const TodoList = () => {
  const filter = useSelector((state) => state.filter);
  const { data: todos, isLoading, isError, isSuccess } = useGetTodosQuery(filter);
  let content = null;
  if (isLoading) {
    content = (
      <>
        <TodoLoader />
        <TodoLoader />
        <TodoLoader />
      </>
    );
  }

  if (isError) {
    content = <Error message='Loading failed' />;
  }
  if (isSuccess && todos.length === 0) {
    content = <Error message='no todos found' />;
  }
  if (isSuccess && todos.length > 0) {
    content = todos.map((todo) => <TodoItem key={todo.id} todo={todo} />);
  }
  return (
    <>
      <div className='mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto'>{content}</div>

      <hr className='mt-4' />
    </>
  );
};

export default TodoList;
